(function() {
  'use strict';
  angular.module('app', [
    'ngAnimate',
    'ngTouch',
    'angular-progress-button-styles',
    'esri.core',
    'esri.map',
    'ngJsTree',
    'ui.router',
    'ui.bootstrap',
    'angular.panels',
    'ui.sortable',
    'xeditable',
    'ngTable',
    'angularSpinner',

    'app.theme',
    'app.pages',
    'app.parcels',

    // API modules and services
    'app.config',
    'app.arcgisonline',
    'app.maps',
    'app.reports',
    'app.tracts',
    'app.navbar',
    'app.sidebar',
    'app.previewpanel'
  ]);
})();
